<template lang="html">
  <!-- start if check for member -->
  <div v-if="member && league" class="row">
    <!-- start profile -->
    <div class="col-12">
      <article class="fc-m-container">
        <div class="fc-m-member">
          <div
            class="fc-m-member__image"
            :style="{
              backgroundImage: `url(https://fc-congress-members.s3.us-east-2.amazonaws.com/${
                member.bioguide
              }.jpeg), url(https://fc-congress-members.s3.us-east-2.amazonaws.com/placeholder_square.jpeg)`
            }"
          ></div>
          <div class="fc-m-member__info">
            <h2 class="fc-m-member__name">
              {{
                member.common_name != ""
                  ? member.common_name
                  : member.first_name
              }}
              {{ member.last_name }}
              <div v-if="member.status === 'inactive'">
                <span class="badge badge-warning">Inactive</span>
              </div>
            </h2>
            <div class="fc-m-member__stat">
              <div class="h4">Chamber:</div>
              {{ member.chamber }}
            </div>
            <div class="fc-m-member__stat">
              <div class="h4">State:</div>
              {{ member.state }}
            </div>
            <div v-if="member.chamber == 'House'" class="fc-m-member__stat">
              <div class="h4">District:</div>
              {{ member.district != 0 ? member.district : "" }}
            </div>
            <div class="fc-m-member__stat">
              <div class="h4">Weekly Average:</div>
              <strong>{{ member.running_average }} pts</strong>
            </div>
            <div class="fc-m-member__stat">
              <div class="h4">Party:</div>
              <div
                class="fc-m-member__party"
                :class="'fc-m-member__party--' + member.party.toLowerCase()"
              >
                <span>{{ member.party }}</span>
                <span>
                  <svg
                    class="fc-a-icon fc-a-icon--size-5 ml-2"
                    :class="'fc-a-icon--' + member.party.toLowerCase()"
                  >
                    <use :xlink:href="'#icon_' + member.party" />
                  </svg>
                </span>
              </div>
            </div>
            <div class="fc-m-member__stat">
              <div class="h4">Website:</div>
              <a target="_blank" :href="member.website">Click here</a>
            </div>
            <div class="fc-m-member__stat">
              <div class="h4">Follow:</div>
              <span class="d-flex">
                <a
                  target="_blank"
                  v-for="social in getSocial"
                  :href="social.url"
                  v-bind:key="social.url"
                >
                  <svg class="fc-a-icon fc-a-icon--size-5 mr-3">
                    <use :xlink:href="'#icon_' + social.name" />
                  </svg>
                </a>
              </span>
            </div>
            <div class="fc-m-member__stat">
              <div class="h4">Team:</div>
              <router-link
                v-if="team"
                :to="`/leagues/${$route.params.leagueId}/teams/${team.id}`"
                >&#10003; {{ team.name }}</router-link
              >
              <span v-else>None</span>
            </div>
          </div>
        </div>
      </article>
    </div>
    <!-- end profile -->
    <!-- start totals -->
    <div class="col-12">
      <article class="fc-m-container">
        <h2>Points by Week</h2>
        <!-- Start Graph -->
        <div class="fc-m-graph">
          <svg
            v-on:click="updateTotals('previous')"
            class="fc-a-icon fc-a-icon--size-8 fc-a-icon--stroke fc-m-graph__nav"
            :class="{ 'fc-m-graph__nav--show': iconNav }"
          >
            <use xlink:href="#icon_previous" />
          </svg>
          <div class="fc-m-graph__wrapper">
            <canvas class="fc-m-graph__canvas" id="myChart"></canvas>
          </div>
          <svg
            v-on:click="updateTotals('next')"
            class="fc-a-icon fc-a-icon--size-8 fc-a-icon--stroke fc-m-graph__nav"
            :class="{ 'fc-m-graph__nav--show': iconNav }"
          >
            <use xlink:href="#icon_next" />
          </svg>
        </div>
        <!-- end Graph -->
        <h2>Points Breakdown</h2>
        <div v-if="actions">
          <div class="d-flex flex-wrap fc-a-highlight">
            <span class="pr-4 m-2"
              >Week: <strong>{{ actionsRequestedWk }}</strong></span
            >
            <span class="pr-4 m-2 "
              >Total Points: <strong>{{ totalRequestedWk }}</strong></span
            >
          </div>
          <!-- start table -->
          <table v-if="actions.results.length" class="table table-striped">
            <thead>
              <tr>
                <th scope="col">Date</th>
                <th scope="col">Points</th>
                <th scope="col">Action</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="action in actions.results" v-bind:key="action.id">
                <td>{{ formatDates(action.datetime, null) }}</td>
                <td>{{ action.points }}</td>
                <td class="fc-a-xs__text--small fc-a-sm__text--medium">
                  <action v-bind:context="action"></action>
                </td>
              </tr>
            </tbody>
          </table>
          <table v-else class="table table-striped">
            <thead>
              <tr>
                <th scope="col">Date</th>
                <th scope="col">Points</th>
                <th scope="col">Action</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td colspan="3">No actions recorded for this week.</td>
              </tr>
            </tbody>
          </table>
          <!-- end table -->
          <div>
            <pagination
              v-if="actionsPrevious || actionsNext"
              v-bind:next="actionsNext"
              v-bind:previous="actionsPrevious"
              @newPage="getActions"
            ></pagination>
          </div>
        </div>
        <div v-else>
          <loader v-bind:embeded="true"></loader>
        </div>
      </article>
    </div>
    <!-- end totals -->
  </div>
  <!-- end if check for member -->
  <loader v-else v-bind:embeded="false"></loader>
</template>

<script>
import { getCookie } from "@/utils/cookies.js";
import Chart from "chart.js";
import Action from "@/views/components/Action";
import Loader from "@/views/components/Loader";
import Pagination from "@/views/components/Pagination";
import moment from "moment";

export default {
  name: "CongressMember",
  components: {
    action: Action,
    loader: Loader,
    pagination: Pagination
  },
  data: function() {
    return {
      member: null,
      league: null,
      team: null,
      totals: null,
      actions: null,
      actionsNext: null,
      actionsPrevious: null,
      actionsRequestedWk: false,
      iconNav: true,
      currentWk: 0,
      totalRequestedWk: 0
    };
  },
  created: function() {
    let app = this;
    this.getLeague().then(function(response) {
      app.$store.commit("breadcrumb/updateDynamicLinks", {
        dynamic_links: [
          {
            static_name: ":league",
            dynamic_name: response.name,
            url: `/leagues/${response.id}`
          },
          {
            static_name: ":congress",
            dynamic_name: "Congress",
            url: `/leagues/${response.id}/congress`
          }
        ]
      });
      app.team = response.teams.find(t =>
        t.congress.includes(app.$route.params.memberId)
      );
      app.league = response;

      app.currentWk = moment();
      app.getMember(app.$route.params.memberId);
    });
  },
  methods: {
    formatDates: function(start, end) {
      let formatted = "";
      if (start && end) {
        let s = start.split("T")[0].split("-");
        let e = end.split("T")[0].split("-");
        formatted = `${s[1]}/${s[2]} - ${e[1]}/${e[2]}`;
      } else {
        let s = start
          ? start.split("T")[0].split("-")
          : end.split("T")[0].split("-");
        formatted = `${s[1]}/${s[2]}`;
      }

      return formatted;
    },
    getActions: function(url) {
      let app = this;

      fetch(url)
        .then(function(response) {
          return response.json();
        })
        .then(function(json) {
          app.actions = json;
          app.actionsNext = json.next;
          app.actionsPrevious = json.previous;
          app.iconNav = true;
        });
    },
    getLeague: function() {
      let app = this;
      return fetch(
        `${process.env.VUE_APP_PLATFORM}/api/leagues/${
          app.$route.params.leagueId
        }`,
        {
          credentials: "include",
          mode: "cors"
        }
      ).then(function(response) {
        return response.json();
      });
    },
    getMember: function(memberId) {
      let app = this;
      let url = process.env.VUE_APP_CONGRESS + "/api/members/" + memberId + "/";
      fetch(url)
        .then(function(response) {
          return response.json();
        })
        .then(function(json) {
          let real_name =
            json.common_name != "" ? json.common_name : json.first_name;
          app.$store.commit("breadcrumb/setCurrentPage", {
            name: real_name + " " + json.last_name
          });
          app.$store.commit("breadcrumb/display");
          app.member = json;
          app.getTotals(app.$route.params.memberId);
        });
    },
    getTotals: function(memberId) {
      let app = this;
      let sunday = app.currentWk.clone().day("Sunday");
      let saturday = app.currentWk.clone().day("Saturday");
      let weekAfter = sunday
        .clone()
        .subtract(4, "weeks")
        .format("YYYY-MM-DD");
      let weekBefore = sunday
        .clone()
        .add(1, "weeks")
        .format("YYYY-MM-DD");

      let url = `${process.env.VUE_APP_CONGRESS}/api/totals/?id=${
        app.$route.params.memberId
      }&week_after=${weekAfter}&week_before=${weekBefore}`;

      fetch(url)
        .then(function(response) {
          return response.json();
        })
        .then(function(json) {
          //update totals with correct points

          let totalsPlaceholder = Array.from({ length: 5 }, (v, i) => {
            // let currentWk = moment().week(app.currentWk);
            let week_cleaned = app.currentWk.clone().subtract(i, "weeks");
            return { points: 0, week_start: week_cleaned.day("Sunday") };
          });
          app.totals = totalsPlaceholder.map((v, i) => {
            let serverWeek = json["results"].find(
              total => total.week_start == v.week_start.format("YYYY-MM-DD")
            );
            v.points = serverWeek ? serverWeek.points : 0;
            return v;
          });

          let actionsUrl = `${
            process.env.VUE_APP_CONGRESS
          }/api/members/${memberId}/actions/?limit=100&offset=0&datetime__gte=${sunday.format(
            "YYYY-MM-DD"
          )}%2000:00:00&datetime__lte=${saturday.format(
            "YYYY-MM-DD"
          )}%2023:59:59`;

          app.actionsRequestedWk = `${sunday.format("MM/DD")}-${saturday.format(
            "MM/DD"
          )}`;

          let currentWk = app.currentWk.clone();
          let requestedWk = app.totals.find(function(total) {
            return (
              total.week_start.day("Sunday").format("YYYY-MM-DD") ==
              currentWk.day("Sunday").format("YYYY-MM-DD")
            );
          });
          app.totalRequestedWk = requestedWk ? requestedWk.points : 0;

          app.getActions(actionsUrl);
          app.makeChart();
        });
    },
    makeChart: function() {
      var app = this;
      var labels_formatted = [];
      var point_data = [];
      for (var i = 0; i < app.totals.length; i++) {
        var lStart = app.totals[i].week_start.day("Sunday").format("MM/DD");
        var lEnd = app.totals[i].week_start.day("Saturday").format("MM/DD");
        labels_formatted.unshift(lStart + " - " + lEnd);
        var pts = app.totals[i].points == null ? 0 : app.totals[i].points;
        point_data.unshift(pts);
      }

      var ctx = document.getElementById("myChart").getContext("2d");
      var chart = new Chart(ctx, {
        // The type of chart we want to create
        type: "line",

        // The data for our dataset
        data: {
          labels: labels_formatted,
          datasets: [
            {
              label: "Points",
              backgroundColor: "#EBF9FF",
              borderColor: "#00b1ef",
              pointBackgroundColor: "#00b1ef",
              pointRadius: 5,
              lineTension: 0,
              data: point_data
            }
          ]
        },

        // Configuration options go here
        options: {
          maintainAspectRatio: false,
          layout: {
            padding: {
              top: 32,
              right: 0,
              bottom: 32,
              left: 0
            }
          },
          legend: {
            labels: {}
          },
          scales: {
            xAxes: [
              {
                gridLines: {
                  lineWidth: 0
                }
              }
            ]
          }
        }
      });
    },
    updateTotals: function(direction) {
      let app = this;
      app.actions = null;
      app.iconNav = false;
      if (direction == "previous") {
        app.currentWk.subtract(1, "weeks");
      } else if (direction == "next") {
        app.currentWk.add(1, "weeks");
      }
      app.getTotals(app.$route.params.memberId);
    }
  },
  computed: {
    getSocial: function() {
      let returnedSocial = [];
      let allowedSocial = [
        {
          name: "youtube_id",
          url: "https://www.youtube.com/channel/{id}/videos"
        },
        { name: "twitter", url: "https://twitter.com/{id}" },
        { name: "facebook", url: "https://facebook.com/{id}" },
        { name: "instagram", url: "https://instagram.com/{id}/" }
      ];
      for (let i = 0; i < allowedSocial.length; i++) {
        let s = allowedSocial[i].name;
        if (s in this.member.social) {
          let socialName = s == "youtube_id" ? "youtube" : s;
          let socialDict = {
            name: socialName,
            url: allowedSocial[i].url.replace("{id}", this.member.social[s])
          };
          returnedSocial.push(socialDict);
        }
      }
      return returnedSocial;
    }
  }
};
</script>

<style lang="scss"></style>
